module.exports = __webpack_public_path__ + "img/皮带轮装配.SLDASM.b6594788.jpg";